import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { useAppearOnScroll } from "@/hooks/useAppearOnScroll";
import { cn } from "@/utils/helpers";
import { ArrowUp } from "lucide-react";
const backToTopContent = {
  label: "Back to Top"
};
const applyDynamicClasses = (shouldAppear: boolean): string => {
  const baseClasses = "hover:rounded-[3.125rem]! hover:w-36! overflow-hidden active:scale-90 [&>span>svg]:delay-50 [&>span>svg]:duration-200 [&>span>svg]:group-hover:-translate-y-12";
  const visibilityClasses = shouldAppear ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none";
  return cn(baseClasses, visibilityClasses);
};
export const BackToTop = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 100
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    shouldAppear
  } = useAppearOnScroll(t0);
  const scrollToTop = _temp;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowUp className="size-4" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== shouldAppear) {
    t2 = applyDynamicClasses(shouldAppear);
    $[2] = shouldAppear;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Button onClick={scrollToTop} variant="secondary" icon={t1} iconPosition="right" isIcon={true} className={t2} aria-label="Back to top" data-testid="back-to-top-button" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== shouldAppear) {
    t4 = shouldAppear && <span className="absolute inset-0 flex items-center justify-center body-small whitespace-nowrap scale-0 group-hover:scale-100 duration-200 z-10 pointer-events-none">{backToTopContent.label}</span>;
    $[6] = shouldAppear;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="fixed bottom-4 right-9 z-100"><div className="relative group">{t3}{t4}</div></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}